import './App.css';
import CacheBuster from 'react-cache-buster';
import { default as data } from '../package.json'
import Routing from './config/Routing';
import CustomLoader from './custom-ui/CustomLoader';
import {ToastContainer,Zoom} from 'react-toastify'
import { useEffect } from 'react';
import { onForegroundMessageListener } from './firebase/firebaseMessaging';

function App() {
    // const isProduction = process.env.NODE_ENV === 'production';
    const isProduction = true;

    useEffect(() => {
    onForegroundMessageListener(); // Listen for foreground notifications
  }, []);
  
    return (
        <CacheBuster
            currentVersion={data.version}
            isEnabled={isProduction} //If false, the library is disabled.
            loadingComponent={<CustomLoader />} //If not pass, nothing appears at the time of new version check.
        >
        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={true} transition={Zoom} />
            <Routing />
        </CacheBuster>
    );
}

export default App;
